// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Admin Dashboard Container - Layout Styles
 * Sidebar navigation and main content area styling
 */

.admin-dashboard-container {
  display: flex;
  min-height: 100vh;
  background: #f8fafc;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
}

/* Sidebar */
.admin-sidebar {
  width: 280px;
  background: #FFFFFF;
  color: #252A33;
  display: flex;
  flex-direction: column;
  position: fixed;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 1000;
  box-shadow: 4px 0 20px rgba(0, 0, 0, 0.1);
  border-right: 1px solid #E5E7EB;
}

.sidebar-header {
  padding: 2rem 1.5rem;
  border-bottom: 1px solid #E5E7EB;
}

.logo {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.logo-icon {
  font-size: 2rem;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #EA580C, #FDBA74);
  border-radius: 12px;
  box-shadow: 0 4px 6px -1px rgba(234, 88, 12, 0.1), 0 2px 4px -1px rgba(234, 88, 12, 0.06);
  /* Hide the emoji icon when using image logo */
  display: none;
}

.logo-image {
  height: 40px;
  width: auto;
  max-width: 200px;
  object-fit: contain;
  margin-right: 0.75rem;
  border-radius: 4px;
}

.logo-text {
  font-size: 1.75rem;
  font-weight: 700;
  color: #252A33;
}

/* Navigation */
.sidebar-nav {
  flex: 1 1;
  padding: 1rem 0;
  overflow-y: auto;
}

.admin-sidebar .nav-item {
  width: 100%;
  background: none;
  border: none;
  color: #252A33;
  padding: 1.25rem 1.5rem;
  display: flex !important;
  flex-direction: row !important;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: left;
  font-size: 1.125rem;
  font-weight: 1000;
  min-height: 70px;
  justify-content: flex-start;
}

.admin-sidebar .nav-item:hover {
  background: #F7F7F8;
  color: #252A33;
  font-weight: 1000;
}

.admin-sidebar .nav-item.active {
  background: linear-gradient(135deg, #EA580C, #FDBA74);
  color: white;
  border-right: 3px solid #FB923C;
  box-shadow: 0 4px 6px -1px rgba(234, 88, 12, 0.1), 0 2px 4px -1px rgba(234, 88, 12, 0.06);
  transform: translateX(4px);
}

.admin-sidebar .nav-item.active .nav-icon {
  background: rgba(255, 255, 255, 0.2);
  transform: scale(1.05);
}

.admin-sidebar .nav-item.active .nav-label {
  font-weight: 700;
}

.admin-sidebar .nav-icon {
  font-size: 1.5rem;
  width: 28px;
  height: 28px;
  text-align: center;
  color: #252A33;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: rgba(37, 42, 51, 0.1);
  backdrop-filter: blur(10px);
  flex-shrink: 0;
}

.admin-sidebar .nav-item:hover .nav-icon {
  color: #252A33;
  background: rgba(37, 42, 51, 0.15);
  transform: scale(1.1);
}

.admin-sidebar .nav-label {
  font-size: 1.125rem;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.025em;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  color: #252A33;
  transition: all 0.3s ease;
  line-height: 1.4;
  text-align: left;
  flex: 1 1;
  word-wrap: break-word;
}

.admin-sidebar .nav-item:hover .nav-label {
  color: #252A33;
  font-weight: 700;
}

/* Sidebar Footer - Enhanced Design */
.sidebar-footer {
  padding: 1.5rem;
  border-top: 1px solid #E5E7EB;
  background: #F7F7F8;
  backdrop-filter: blur(10px);
}

.user-section {
  background: #FFFFFF;
  border: 1px solid #E5E7EB;
  border-radius: 16px;
  padding: 1.25rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  animation: slideInUp 0.5s ease-out;
}

.user-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, #EA580C, #FDBA74, #FB923C);
  border-radius: 16px 16px 0 0;
}

.user-section:hover {
  background: #FFFFFF;
  border-color: #FFEAD5;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px -5px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.user-info {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.user-avatar {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #EA580C, #FDBA74);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 700;
  font-size: 1.125rem;
  box-shadow: 0 6px 12px -2px rgba(234, 88, 12, 0.3), 0 4px 6px -1px rgba(234, 88, 12, 0.1);
  border: 3px solid rgba(255, 255, 255, 0.2);
  position: relative;
}

.user-avatar::after {
  content: '';
  position: absolute;
  bottom: 2px;
  right: 2px;
  width: 12px;
  height: 12px;
  background: #22c55e;
  border: 2px solid #1e1b4b;
  border-radius: 50%;
  box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.3);
  animation: pulse 2s infinite;
}

@keyframes pulse {

  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }

  50% {
    opacity: 0.8;
    transform: scale(1.1);
  }
}

.user-details {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1 1;
}

.user-name {
  font-weight: 700;
  color: #252A33;
  font-size: 1rem;
  line-height: 1.4;
  word-break: break-word;
  text-shadow: none;
}

/* Main Content */
.admin-main-content {
  flex: 1 1;
  margin-left: 280px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: #f9fafb;
}

/* Top Bar */
.admin-topbar {
  background: linear-gradient(135deg, #EA580C, #FDBA74);
  border-bottom: 1px solid #C2410C;
  padding: 1.5rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 4px 6px -1px rgba(234, 88, 12, 0.1), 0 2px 4px -1px rgba(234, 88, 12, 0.06);
  position: sticky;
  top: 0;
  z-index: 100;
}

.topbar-left {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.back-to-dashboard-btn {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
  padding: 0.75rem 1.5rem;
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  font-size: 0.875rem;
  backdrop-filter: blur(10px);
}

.back-to-dashboard-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.back-icon {
  font-size: 1.25rem;
}

.page-title {
  font-size: 1.875rem;
  font-weight: 800;
  color: white;
  margin: 0;
  letter-spacing: -0.025em;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Content Area */
.admin-content {
  flex: 1 1;
  padding: 0;
  overflow-x: hidden;
}

/* Loading State */
.dashboard-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #f8fafc;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .admin-sidebar {
    width: 250px;
  }

  .admin-main-content {
    margin-left: 250px;
  }
}

@media (max-width: 768px) {
  .admin-sidebar {
    width: 100%;
    height: auto;
    position: relative;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
  }

  .admin-sidebar.open {
    transform: translateX(0);
  }

  .admin-main-content {
    margin-left: 0;
    width: 100%;
  }

  .admin-topbar {
    padding: 1rem;
  }

  .page-title {
    font-size: 1.5rem;
  }

  .admin-sidebar .nav-item {
    padding: 0.875rem 1rem;
    min-height: 55px;
  }

  .admin-sidebar .nav-icon {
    font-size: 1.125rem;
    width: 22px;
    height: 22px;
  }

  .admin-sidebar .nav-label {
    font-size: 0.8rem;
  }

  .sidebar-footer {
    padding: 1rem;
  }

  .user-section {
    padding: 1rem;
  }

  .user-info {
    gap: 0.75rem;
  }

  .user-avatar {
    width: 44px;
    height: 44px;
    font-size: 1rem;
  }

  .user-name {
    font-size: 0.85rem;
  }

  .logout-btn {
    padding: 0.75rem 1rem;
    font-size: 0.8rem;
  }
}

@media (max-width: 480px) {
  .admin-topbar {
    padding: 0.75rem 1rem;
  }

  .topbar-left {
    gap: 1rem;
  }

  .back-to-dashboard-btn {
    padding: 0.5rem 1rem;
    font-size: 0.9rem;
  }

  .page-title {
    font-size: 1.25rem;
  }

  .sidebar-header {
    padding: 1.5rem 1rem;
  }

  .admin-sidebar .nav-item {
    padding: 0.75rem 0.75rem;
    min-height: 50px;
  }

  .admin-sidebar .nav-icon {
    font-size: 1rem;
    width: 20px;
    height: 20px;
  }

  .admin-sidebar .nav-label {
    font-size: 0.75rem;
  }

  .user-section {
    padding: 1rem;
  }

  .user-avatar {
    width: 40px;
    height: 40px;
    font-size: 1rem;
  }

  .user-name {
    font-size: 0.8rem;
  }

  .logout-btn {
    padding: 0.75rem 1rem;
    font-size: 0.8rem;
  }

  .logout-btn .logout-text {
    display: none;
  }
}

/* Animation for smooth transitions */
.admin-content>* {
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Old logout button styles removed - now using .btn classes from header components */

/* Focus states for accessibility */
.admin-sidebar .nav-item:focus,
.back-to-dashboard-btn:focus,
.logout-btn:focus {
  outline: 2px solid #0D3B66;
  outline-offset: 2px;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Scrollbar styling for sidebar */
.sidebar-nav::-webkit-scrollbar {
  width: 4px;
}

.sidebar-nav::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
}

.sidebar-nav::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
}

.sidebar-nav::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/AdminDashboardContainer.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yFAAyF;AAC3F;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,OAAO;EACP,MAAM;EACN,aAAa;EACb,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qDAAqD;EACrD,mBAAmB;EACnB,yFAAyF;EACzF,8CAA8C;EAC9C,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,+BAA+B;EAC/B,yFAAyF;EACzF,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;EACjC,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,yFAAyF;EACzF,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,SAAO;EACP,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,6DAA6D;EAC7D,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,kFAAkF;AACpF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,yFAAyF;EACzF,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C;EAC5C,4BAA4B;AAC9B;;AAEA;;EAEE;;IAEE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,qBAAqB;EACvB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,qDAAqD;EACrD,gCAAgC;EAChC,oBAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yFAAyF;EACzF,gBAAgB;EAChB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;EAC1C,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,wCAAwC;EACxC,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,UAAU;EACV,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,qCAAqC;AACrC;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,qFAAqF;;AAErF,mCAAmC;AACnC;;;EAGE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,kCAAkC;AAClC;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":["/**\n * Admin Dashboard Container - Layout Styles\n * Sidebar navigation and main content area styling\n */\n\n.admin-dashboard-container {\n  display: flex;\n  min-height: 100vh;\n  background: #f8fafc;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;\n}\n\n/* Sidebar */\n.admin-sidebar {\n  width: 280px;\n  background: #FFFFFF;\n  color: #252A33;\n  display: flex;\n  flex-direction: column;\n  position: fixed;\n  height: 100vh;\n  left: 0;\n  top: 0;\n  z-index: 1000;\n  box-shadow: 4px 0 20px rgba(0, 0, 0, 0.1);\n  border-right: 1px solid #E5E7EB;\n}\n\n.sidebar-header {\n  padding: 2rem 1.5rem;\n  border-bottom: 1px solid #E5E7EB;\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.logo-icon {\n  font-size: 2rem;\n  width: 44px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #EA580C, #FDBA74);\n  border-radius: 12px;\n  box-shadow: 0 4px 6px -1px rgba(234, 88, 12, 0.1), 0 2px 4px -1px rgba(234, 88, 12, 0.06);\n  /* Hide the emoji icon when using image logo */\n  display: none;\n}\n\n.logo-image {\n  height: 40px;\n  width: auto;\n  max-width: 200px;\n  object-fit: contain;\n  margin-right: 0.75rem;\n  border-radius: 4px;\n}\n\n.logo-text {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: #252A33;\n}\n\n/* Navigation */\n.sidebar-nav {\n  flex: 1;\n  padding: 1rem 0;\n  overflow-y: auto;\n}\n\n.admin-sidebar .nav-item {\n  width: 100%;\n  background: none;\n  border: none;\n  color: #252A33;\n  padding: 1.25rem 1.5rem;\n  display: flex !important;\n  flex-direction: row !important;\n  align-items: center;\n  gap: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-align: left;\n  font-size: 1.125rem;\n  font-weight: 1000;\n  min-height: 70px;\n  justify-content: flex-start;\n}\n\n.admin-sidebar .nav-item:hover {\n  background: #F7F7F8;\n  color: #252A33;\n  font-weight: 1000;\n}\n\n.admin-sidebar .nav-item.active {\n  background: linear-gradient(135deg, #EA580C, #FDBA74);\n  color: white;\n  border-right: 3px solid #FB923C;\n  box-shadow: 0 4px 6px -1px rgba(234, 88, 12, 0.1), 0 2px 4px -1px rgba(234, 88, 12, 0.06);\n  transform: translateX(4px);\n}\n\n.admin-sidebar .nav-item.active .nav-icon {\n  background: rgba(255, 255, 255, 0.2);\n  transform: scale(1.05);\n}\n\n.admin-sidebar .nav-item.active .nav-label {\n  font-weight: 700;\n}\n\n.admin-sidebar .nav-icon {\n  font-size: 1.5rem;\n  width: 28px;\n  height: 28px;\n  text-align: center;\n  color: #252A33;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  background: rgba(37, 42, 51, 0.1);\n  backdrop-filter: blur(10px);\n  flex-shrink: 0;\n}\n\n.admin-sidebar .nav-item:hover .nav-icon {\n  color: #252A33;\n  background: rgba(37, 42, 51, 0.15);\n  transform: scale(1.1);\n}\n\n.admin-sidebar .nav-label {\n  font-size: 1.125rem;\n  font-weight: 600;\n  text-transform: none;\n  letter-spacing: 0.025em;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;\n  color: #252A33;\n  transition: all 0.3s ease;\n  line-height: 1.4;\n  text-align: left;\n  flex: 1;\n  word-wrap: break-word;\n}\n\n.admin-sidebar .nav-item:hover .nav-label {\n  color: #252A33;\n  font-weight: 700;\n}\n\n/* Sidebar Footer - Enhanced Design */\n.sidebar-footer {\n  padding: 1.5rem;\n  border-top: 1px solid #E5E7EB;\n  background: #F7F7F8;\n  backdrop-filter: blur(10px);\n}\n\n.user-section {\n  background: #FFFFFF;\n  border: 1px solid #E5E7EB;\n  border-radius: 16px;\n  padding: 1.25rem;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  overflow: hidden;\n  animation: slideInUp 0.5s ease-out;\n}\n\n.user-section::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: linear-gradient(90deg, #EA580C, #FDBA74, #FB923C);\n  border-radius: 16px 16px 0 0;\n}\n\n.user-section:hover {\n  background: #FFFFFF;\n  border-color: #FFEAD5;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px -5px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.user-avatar {\n  width: 48px;\n  height: 48px;\n  background: linear-gradient(135deg, #EA580C, #FDBA74);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: 700;\n  font-size: 1.125rem;\n  box-shadow: 0 6px 12px -2px rgba(234, 88, 12, 0.3), 0 4px 6px -1px rgba(234, 88, 12, 0.1);\n  border: 3px solid rgba(255, 255, 255, 0.2);\n  position: relative;\n}\n\n.user-avatar::after {\n  content: '';\n  position: absolute;\n  bottom: 2px;\n  right: 2px;\n  width: 12px;\n  height: 12px;\n  background: #22c55e;\n  border: 2px solid #1e1b4b;\n  border-radius: 50%;\n  box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.3);\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n\n  0%,\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n\n  50% {\n    opacity: 0.8;\n    transform: scale(1.1);\n  }\n}\n\n.user-details {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  flex: 1;\n}\n\n.user-name {\n  font-weight: 700;\n  color: #252A33;\n  font-size: 1rem;\n  line-height: 1.4;\n  word-break: break-word;\n  text-shadow: none;\n}\n\n/* Main Content */\n.admin-main-content {\n  flex: 1;\n  margin-left: 280px;\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  background: #f9fafb;\n}\n\n/* Top Bar */\n.admin-topbar {\n  background: linear-gradient(135deg, #EA580C, #FDBA74);\n  border-bottom: 1px solid #C2410C;\n  padding: 1.5rem 2rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-shadow: 0 4px 6px -1px rgba(234, 88, 12, 0.1), 0 2px 4px -1px rgba(234, 88, 12, 0.06);\n  position: sticky;\n  top: 0;\n  z-index: 100;\n}\n\n.topbar-left {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n}\n\n.back-to-dashboard-btn {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  padding: 0.75rem 1.5rem;\n  border-radius: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  font-size: 0.875rem;\n  backdrop-filter: blur(10px);\n}\n\n.back-to-dashboard-btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n  border-color: rgba(255, 255, 255, 0.5);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.back-icon {\n  font-size: 1.25rem;\n}\n\n.page-title {\n  font-size: 1.875rem;\n  font-weight: 800;\n  color: white;\n  margin: 0;\n  letter-spacing: -0.025em;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* Content Area */\n.admin-content {\n  flex: 1;\n  padding: 0;\n  overflow-x: hidden;\n}\n\n/* Loading State */\n.dashboard-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background: #f8fafc;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .admin-sidebar {\n    width: 250px;\n  }\n\n  .admin-main-content {\n    margin-left: 250px;\n  }\n}\n\n@media (max-width: 768px) {\n  .admin-sidebar {\n    width: 100%;\n    height: auto;\n    position: relative;\n    transform: translateX(-100%);\n    transition: transform 0.3s ease;\n  }\n\n  .admin-sidebar.open {\n    transform: translateX(0);\n  }\n\n  .admin-main-content {\n    margin-left: 0;\n    width: 100%;\n  }\n\n  .admin-topbar {\n    padding: 1rem;\n  }\n\n  .page-title {\n    font-size: 1.5rem;\n  }\n\n  .admin-sidebar .nav-item {\n    padding: 0.875rem 1rem;\n    min-height: 55px;\n  }\n\n  .admin-sidebar .nav-icon {\n    font-size: 1.125rem;\n    width: 22px;\n    height: 22px;\n  }\n\n  .admin-sidebar .nav-label {\n    font-size: 0.8rem;\n  }\n\n  .sidebar-footer {\n    padding: 1rem;\n  }\n\n  .user-section {\n    padding: 1rem;\n  }\n\n  .user-info {\n    gap: 0.75rem;\n  }\n\n  .user-avatar {\n    width: 44px;\n    height: 44px;\n    font-size: 1rem;\n  }\n\n  .user-name {\n    font-size: 0.85rem;\n  }\n\n  .logout-btn {\n    padding: 0.75rem 1rem;\n    font-size: 0.8rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .admin-topbar {\n    padding: 0.75rem 1rem;\n  }\n\n  .topbar-left {\n    gap: 1rem;\n  }\n\n  .back-to-dashboard-btn {\n    padding: 0.5rem 1rem;\n    font-size: 0.9rem;\n  }\n\n  .page-title {\n    font-size: 1.25rem;\n  }\n\n  .sidebar-header {\n    padding: 1.5rem 1rem;\n  }\n\n  .admin-sidebar .nav-item {\n    padding: 0.75rem 0.75rem;\n    min-height: 50px;\n  }\n\n  .admin-sidebar .nav-icon {\n    font-size: 1rem;\n    width: 20px;\n    height: 20px;\n  }\n\n  .admin-sidebar .nav-label {\n    font-size: 0.75rem;\n  }\n\n  .user-section {\n    padding: 1rem;\n  }\n\n  .user-avatar {\n    width: 40px;\n    height: 40px;\n    font-size: 1rem;\n  }\n\n  .user-name {\n    font-size: 0.8rem;\n  }\n\n  .logout-btn {\n    padding: 0.75rem 1rem;\n    font-size: 0.8rem;\n  }\n\n  .logout-btn .logout-text {\n    display: none;\n  }\n}\n\n/* Animation for smooth transitions */\n.admin-content>* {\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Old logout button styles removed - now using .btn classes from header components */\n\n/* Focus states for accessibility */\n.admin-sidebar .nav-item:focus,\n.back-to-dashboard-btn:focus,\n.logout-btn:focus {\n  outline: 2px solid #0D3B66;\n  outline-offset: 2px;\n}\n\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Scrollbar styling for sidebar */\n.sidebar-nav::-webkit-scrollbar {\n  width: 4px;\n}\n\n.sidebar-nav::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.sidebar-nav::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.3);\n  border-radius: 2px;\n}\n\n.sidebar-nav::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.5);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
